import Services from './base-services'
import mapParameters from '../utils/map-parameters'

const service = new Services('dictionary');


export default {
    getMeaning(word: string) {
        return service.contentGet(word, undefined, true);
    },
}
